import { ReactNode, useRef } from 'react';
import { StickyDetailHeader } from './sticky-detail-header';
import styles from './detail-page-with-sticky-header.module.css';

export interface DetailPageWithStickyHeaderProps {
    title?: string;
    subtitle?: string;
    /* Renders subtitle next to the title instead of stacked below it. */
    inlineSubtitle?: boolean;
    meta?: ReactNode;
    imageUrl?: string;
    renderActions?: () => ReactNode;
    banner: ReactNode;
    children?: ReactNode;
}

export function DetailPageWithStickyHeader({
    title,
    subtitle,
    inlineSubtitle,
    meta,
    imageUrl,
    renderActions,
    banner,
    children,
}: DetailPageWithStickyHeaderProps) {
    const bannerRef = useRef<HTMLDivElement>(null);

    return (
        <div className={styles['detail-page-with-sticky-header']}>
            <div ref={bannerRef}>{banner}</div>
            <StickyDetailHeader
                targetRef={bannerRef}
                title={title}
                subtitle={subtitle}
                inlineSubtitle={inlineSubtitle}
                meta={meta}
                imageUrl={imageUrl}
                renderActions={renderActions}
            />
            {children}
        </div>
    );
}
